(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-video-story"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
		const videoStoryButtons = document.querySelectorAll('.mm-product-form-videos-story-content');

		videoStoryButtons.forEach(button => {
			button.addEventListener('click', function() {
				const videoContainer = this.nextElementSibling;
				if (videoContainer && videoContainer.classList.contains('mm-product-form-videos-story-video-container')) {
					// Afficher le conteneur avant d'ajouter la classe pour la transition
					videoContainer.classList.add('mm-open');
					button.setAttribute("aria-expanded", "true");
					videoContainer.setAttribute("aria-hidden", "false");

					// Lancer la vidéo automatiquement après un court délai pour s'assurer que le conteneur est visible
					setTimeout(() => {
						const video = videoContainer.querySelector('video');
						if (video) {
							video.muted = true;
							video.play().catch(err => {
								console.log('Erreur lors de la lecture de la vidéo:', err);
							});
						} else {
							console.warn('Aucune vidéo trouvée dans le conteneur');
						}
					}, 100);

					// Arrêter Lenis quand la vidéo modale s'ouvre
					window.videoModalOpen = true;
					if (typeof stopLenis === 'function') {
						stopLenis();
					}
				} else {
					console.warn('Conteneur vidéo non trouvé pour ce bouton');
				}
			});
		});

		// Fonction pour arrêter la vidéo et fermer la modal
		function closeVideoModal(videoContainer, button = null) {
			videoContainer.classList.remove('mm-open');
			if (button) {
				button.setAttribute("aria-expanded", "false");
			}
			videoContainer.setAttribute("aria-hidden", "true");
			const video = videoContainer.querySelector('video');
			if (video) {
				video.pause();
				video.currentTime = 0;
			}
			// Relancer Lenis quand la vidéo modale se ferme
			window.videoModalOpen = false;
			if (typeof startLenis === 'function') {
				startLenis();
			}
		}

		// Fermer la vidéo en cliquant sur l'icône de fermeture
		const closeButtons = document.querySelectorAll('.mm-product-form-videos-story-video-container .mm-icon-close');
		closeButtons.forEach(closeBtn => {
			closeBtn.addEventListener('click', function() {
				const videoContainer = this.closest('.mm-product-form-videos-story-video-container');
				if (videoContainer) {
					const relatedButton = document.querySelector(`[aria-controls="${videoContainer.id}"]`) ||
						videoContainer.previousElementSibling;
					closeVideoModal(videoContainer, relatedButton);
				}
			});
		});

		// Fermer la vidéo en cliquant en dehors
		const videoContainers = document.querySelectorAll('.mm-product-form-videos-story-video-container');
		videoContainers.forEach(container => {
			container.addEventListener('click', function(e) {
				if (e.target === this) {
					const relatedButton = document.querySelector(`[aria-controls="${this.id}"]`) ||
						this.previousElementSibling;
					closeVideoModal(this, relatedButton);
				}
			});
		});

		// Masquer l'image de couverture quand la vidéo commence
		const videos = document.querySelectorAll('.mm-product-form-videos-story-video');
		videos.forEach(video => {
			video.addEventListener('play', function() {
				const poster = this.parentElement.querySelector('.mm-video-poster');
				if (poster) {
					poster.classList.add('mm-hidden');
				}
			});
		});

		// Fermer la vidéo avec la touche "Escape"
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				const openContainer = document.querySelector('.mm-product-form-videos-story-video-container.mm-open');
				if (openContainer) {
					const relatedButton = document.querySelector(`[aria-controls="${openContainer.id}"]`) ||
						openContainer.previousElementSibling;
					closeVideoModal(openContainer, relatedButton);
				}
			}
		});
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-video-story2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const videoStoryButtons = document.querySelectorAll('.mm-product-form-videos-story-content');

    videoStoryButtons.forEach((button) => {
      button.addEventListener('click', function () {
		const id = this.dataset.videoId;
		const videoContainer = document.getElementById(id);
        if (videoContainer && videoContainer.classList.contains('mm-product-form-videos-story-video-container')) {
          videoContainer.classList.add('mm-open');
          button.setAttribute('aria-expanded', 'true');
          videoContainer.hidden = false;
          videoContainer.setAttribute('aria-hidden', 'false');
          // Lancer la vidéo automatiquement
          const video = videoContainer.querySelector('video');
          if (video) {
            video.muted = true;
            video.play();
          }
          // Arrêter Lenis quand la vidéo modale s'ouvre
          window.videoModalOpen = true;
          if (typeof stopLenis === 'function') {
            stopLenis();
          }
        }
      });
    });

    // Fonction pour arrêter la vidéo et fermer la modal
    function closeVideoModal(videoContainer, button = null) {
      videoContainer.classList.remove('mm-open');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
      videoContainer.hidden = true;
      videoContainer.setAttribute('aria-hidden', 'true');
      const video = videoContainer.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      // Relancer Lenis quand la vidéo modale se ferme
      window.videoModalOpen = false;
      if (typeof startLenis === 'function') {
        startLenis();
      }
    }

    // Fermer la vidéo en cliquant sur l'icône de fermeture
    const closeButtons = document.querySelectorAll('.mm-product-form-videos-story-video-container .mm-icon-close');
    closeButtons.forEach((closeBtn) => {
      closeBtn.addEventListener('click', function () {
        const videoContainer = this.closest('.mm-product-form-videos-story-video-container');
        if (videoContainer) {
          const relatedButton =
            document.querySelector(`[aria-controls="${videoContainer.id}"]`) || videoContainer.previousElementSibling;
          closeVideoModal(videoContainer, relatedButton);
        }
      });
    });

    // Fermer la vidéo en cliquant en dehors
    const videoContainers = document.querySelectorAll('.mm-product-form-videos-story-video-container');
    videoContainers.forEach((container) => {
      container.addEventListener('click', function (e) {
        if (e.target === this) {
          const relatedButton = document.querySelector(`[aria-controls="${this.id}"]`) || this.previousElementSibling;
          closeVideoModal(this, relatedButton);
        }
      });
    });

    // Masquer l'image de couverture quand la vidéo commence
    const videos = document.querySelectorAll('.mm-product-form-videos-story-video');
    videos.forEach((video) => {
      video.addEventListener('play', function () {
        const poster = this.parentElement.querySelector('.mm-video-poster');
        if (poster) {
          poster.classList.add('mm-hidden');
        }
      });
    });

    // Fermer la vidéo avec la touche "Escape"
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        const openContainer = document.querySelector('.mm-product-form-videos-story-video-container.mm-open');
        if (openContainer) {
          const relatedButton =
            document.querySelector(`[aria-controls="${openContainer.id}"]`) || openContainer.previousElementSibling;
          closeVideoModal(openContainer, relatedButton);
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
